import InputTheme from "../../generic/input";

export default function InputVerification({...props}) {
  return <InputTheme size="small" variant="outlined" sx={{ width: "40px", height: "35px"}} {...props}></InputTheme>;
}
